<template>
  <div id="v-admin-panel-followers">
    <ul>{{collective.followers}}</ul>
  </div>
</template>
<script>
export default {
  props: ['collective']
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/General/AdminFollowers.vue